export default "__VITE_ASSET__CYrIRHgO__"